import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { Message } from 'src/app/shared/models/domain';
import { Account, AccountTransactionEntry, Transaction } from 'src/app/shared/models/finance';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { FinanceService } from 'src/app/shared/services/finance.service';
@Component({
  selector: 'app-manage-transaction-entry',
  templateUrl: './manage-transaction-entry.component.html',
  styleUrls: ['./manage-transaction-entry.component.scss']
})
export class ManageTransactionEntryComponent implements OnInit {
  @Input() transactionEntry: AccountTransactionEntry;
  @Input() context: Context;
  @Input() transactionEntries: AccountTransactionEntry[] = [];
  @Input() transaction: Transaction;
  public accounts: Account[] = [];
  public transactionEntryForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;
  public isLoading: boolean = true;

  constructor(
    private financeService: FinanceService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.setTransactionEntry(this.transactionEntry);
    this.financeService.getAccounts(this.context.companyId).subscribe(accounts => this.accounts = accounts);
    this.transactionEntryForm.get('byAccount').valueChanges.subscribe(value => {
      if (value) { 
        this.transactionEntryForm.patchValue({ credit: true }, { emitEvent: false });
      }
    });
  }

  public setTransactionEntry(transactionEntry?: AccountTransactionEntry) {
    if (!transactionEntry)
      transactionEntry = {
        id: null,
        amount: null,
        particular: null,
        transactionId: this.transaction?.id,
        accountId: null,
        accountName: null,
        disabled: false,
        byAccount: true,
        credit: false,
      } as AccountTransactionEntry;
    this.transactionEntryForm = this.fb.group({
      id: this.fb.control(transactionEntry?.id || null),
      amount: this.fb.control(transactionEntry.amount, [Validators.required]),
      particular: this.fb.control(transactionEntry.particular, [Validators.required]),
      transactionId: this.fb.control(transactionEntry.transactionId, [Validators.required]),
      accountId: this.fb.control(transactionEntry.accountId, [Validators.required]),
      accountName: this.fb.control(transactionEntry.accountName, []),
      disabled: this.fb.control(transactionEntry.disabled, []),
      byAccount: this.fb.control(transactionEntry.byAccount, []),
      credit: this.fb.control(transactionEntry.credit, []),
    });
    this.transactionEntryForm.valueChanges.subscribe(value => this.modified = true);
  }

  get t() {
    return this.transactionEntryForm.controls;
  }

  public saveTransactionEntry(inProgress?: any) {
    this.submitted = true;
    if (this.transactionEntryForm.valid) {
      const transactionEntry: AccountTransactionEntry = this.transactionEntryForm.value;
      if (this.transactionEntries.length === 0 && !this.transactionEntryForm.value.byAccount) {
        this.commonService.setToastr(400, 'The first transaction entry must be "By Account".');
        inProgress.value = false;
        return;
      }
      if (transactionEntry.byAccount) {
        const existingByAccount = this.transactionEntries.find(
          (t) => t.byAccount && (this.transactionEntry?.id ? t.id !== this.transactionEntry.id : true)
        );
        if (existingByAccount) {
          this.commonService.setToastr(400, 'Only the first entry can be "By Account".');
          inProgress.value = false;
          return;
        }
      }      
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `Transaction ${transactionEntry.accountName} has been updated successfully!`);
        return;
      }
  
      inProgress.value = true;
  
      if (transactionEntry.id) {
        this.financeService.updateAccountTransactionEntry(transactionEntry.id, transactionEntry).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, response.text);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, response.text);
            }
          },
        });
      } else {
        this.financeService.createAccountTransactionEntry(transactionEntry).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, response.text);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, response.text);
            }
          },
        });
      }
    }
  }
  

}